import type { ScopeResponse } from "@k8s-dashboard/contracts";
import { isNamespaceSelectionCapability } from "@/state/namespaceSelection";

export const PREFERENCE_PARTITION_LENGTH = 47;
export const PREFERENCE_PARTITION_PATTERN = /^pp1_[A-Za-z0-9_-]{43}$/;

export function isPreferencePartition(value: unknown): value is string {
  return typeof value === "string" && value.length === PREFERENCE_PARTITION_LENGTH && PREFERENCE_PARTITION_PATTERN.test(value);
}

/**
 * `/scope`에는 이미 생성된 TypeScript 계약이 있습니다. 이 runtime 경계는 잘못된 선택
 * partition을 저장소 코드가 보기 전에 추가로 제거합니다. 필수 Scope 데이터는 계속
 * fail-closed이고, 유효한 cluster·capability를 숨기지 않은 채 선택 설정 persistence만
 * 사용할 수 없게 됩니다. 브라우저에서는 신원을 파생하지 않습니다.
 */
export function parseScopeResponse(value: unknown): ScopeResponse {
  if (!value || typeof value !== "object" || Array.isArray(value)) throw new Error("invalid scope");
  const record = value as Record<string, unknown>;
  if (!Array.isArray(record.clusters)) throw new Error("invalid scope");
  const parsed = { ...record };
  if (record.preferencePartition !== undefined && !isPreferencePartition(record.preferencePartition)) {
    delete parsed.preferencePartition;
  }
  if (record.namespaceSelection !== undefined && !isNamespaceSelectionCapability(record.namespaceSelection)) {
    delete parsed.namespaceSelection;
  }
  return parsed as unknown as ScopeResponse;
}
